module.exports = __webpack_public_path__ + "media/images/sprite/ico-linkedin@2x-10f49c5f27ad5e43bb61fa5201fdae0f.png";